"use client"

import { ReactNode } from "react"
import { NpButton, NpButtonProps } from "src/components/np-design/components/NpButton"
import { scrollToId } from "src/utilities/scroll"

export type NpScrollButtonProps = Omit<NpButtonProps, "onClick"> & {
  toId: string
  children: ReactNode
}

export const NpScrollButton = ({ toId, ...props }: NpScrollButtonProps) => {
  return <NpButton {...props} onClick={() => scrollToId(toId)} />
}
